import { useRef, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { RiInstanceLine } from 'react-icons/ri';

import ToggleActive from '@lib/core/src/components/ToggleActive';
import palette from '@lib/core/src/theme/palette';
import { styled, TextField } from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';

import { WorkflowDtoStatus } from '@/api/generated';
import { Card, ToggleBox, Label, HelperText, Row } from '@/components/AiWorkflow/AiWorkflowStyles';
import { createdFromToIcon } from '@/pages/JamiesCapabilities/featuredTemplatesData';

const Container = styled(Card)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: 16
});

const IconBox = styled('div')({
  width: 58,
  height: 58,
  borderRadius: 8,
  background: palette.grey[100],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${palette.grey[1200]}`
});

const Texts = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  flexGrow: 1,
  gap: 4
});

const NameInput = styled(TextField)({
  '& .MuiInputBase-root': {
    fontFamily: 'Reddit Sans',
    fontWeight: 600,
    fontSize: 24,
    padding: 0,
    background: 'transparent',
    boxShadow: 'none',
    flexGrow: 1,
    color: palette.black
  },
  '& .MuiInputBase-input': {
    padding: 0,
    background: 'transparent'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  },
  width: 'auto'
});

const Title = () => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const {
    register,
    formState: { errors },
    watch,
    setValue
  } = useFormContext();

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <Container>
      <IconBox>
        {watch('createdFrom') ? (
          <img src={createdFromToIcon[watch('createdFrom')]} alt="Logo" />
        ) : (
          <RiInstanceLine size={24} color={palette.grey[600]} />
        )}
      </IconBox>
      <Texts>
        <Row>
          <Label>Name</Label>
          <HelperText>
            {typeof errors.title?.message === 'string' ? errors.title.message : '\u00A0'}
          </HelperText>
        </Row>
        <NameInput
          {...register('title')}
          inputRef={inputRef}
          value={watch('title')}
          error={Boolean(errors.title)}
          placeholder="New Agent"
          variant="outlined"
          autoComplete="off"
        />
      </Texts>
      {isLargeScreen && (
        <ToggleBox>
          <ToggleActive
            active={watch('status') === WorkflowDtoStatus.enabled}
            onChange={val =>
              setValue('status', val ? WorkflowDtoStatus.enabled : WorkflowDtoStatus.disabled)
            }
          />
        </ToggleBox>
      )}
    </Container>
  );
};

export default Title;
